import { CommonEnums } from 'dashboard-services/api/common';
import { DataLakeReadableConsts } from 'dashboard-services/api/dataLake';
import { DataStorageEnums, GetDataBody, Key } from 'dashboard-services/api/dataStorage';
import Query from 'dashboard-services/api/Query';
import { ActionService, CommonService, ReduxService } from 'dashboard-services/services';
import TimeService from 'dashboard-services/services/TimeService';
import { globalActions } from 'primary-components';

import getApiConfig from 'api/ApiConfig';
import properties from 'resources/constants/properties.json';

import { basicCustomInsightActions, inputParamsCustomInsightActions } from './';
import additionalColumnsCustomInsightActions from './additionalColumns';
import basicCustomInsightConsts from './basicConsts';

import dayjs from 'dayjs';

import Papa from 'papaparse';

// !!IMPORTANT!!
// This file contains actions related to the custom insight TABLE and STATS modules.
export default (() => {
  const NEW_FORMULA_COLUMN_NAME = "New Symbol"
  const TILE_DATA_ERROR_MESSAGE = "Could not load the table data."
  const { ALL_COLUMNS_VALUE, getNormalizedTableColumnsAndData } = additionalColumnsCustomInsightActions

  const ADD_COLUMN = 'ADD_COLUMN_TABLE_CUSTOM_INSIGHT'
  const addColumn = ActionService.makeActionCreator(ADD_COLUMN, 'index', 'value')

  const ADD_CONDITIONAL_FORMATTING = 'ADD_CONDITIONAL_FORMATTING_TABLE_CUSTOM_INSIGHT'
  const addConditionalFormatting = ActionService.makeActionCreator(ADD_CONDITIONAL_FORMATTING, 'index', 'value')

  const COPY_CONDITIONAL_FORMATTING = 'COPY_CONDITIONAL_FORMATTING_TABLE_CUSTOM_INSIGHT'
  const copyConditionalFormatting = ActionService.makeActionCreator(COPY_CONDITIONAL_FORMATTING, 'copyIndex', 'tileIndex')
  
  const REMOVE_CONDITIONAL_FORMATTING = 'REMOVE_CONDITIONAL_FORMATTING_TABLE_CUSTOM_INSIGHT'
  const removeConditionalFormatting = ActionService.makeActionCreator(REMOVE_CONDITIONAL_FORMATTING, 'conditionalFormattingIndex', 'tileIndex')

  const CHANGE_CONDITIONAL_FORMATTING = 'CHANGE_CONDITIONAL_FORMATTING_TABLE_CUSTOM_INSIGHT'
  const changeConditionalFormatting = ActionService.makeActionCreator(CHANGE_CONDITIONAL_FORMATTING, 'value', 'name', 'conditionalFormattingIndex', 'tileIndex')
  
  const ADD_ADVANCED_SORTING_COLUMN = 'ADD_ADVANCED_SORTING_COLUMN_TABLE_CUSTOM_INSIGHT'
  const addAdvancedSortingColumn = ActionService.makeActionCreator(ADD_ADVANCED_SORTING_COLUMN, 'index', 'value')
  
  const REMOVE_ADVANCED_SORTING_COLUMN = 'REMOVE_ADVANCED_SORTING_COLUMN_TABLE_CUSTOM_INSIGHT'
  const removeAdvancedSortingColumn = ActionService.makeActionCreator(REMOVE_ADVANCED_SORTING_COLUMN, 'advancedSortingColumnIndex', 'tileIndex')

  const CHANGE_ADVANCED_SORTING_COLUMN = 'CHANGE_ADVANCED_SORTING_COLUMN_TABLE_CUSTOM_INSIGHT'
  const changeAdvancedSortingColumn = ActionService.makeActionCreator(CHANGE_ADVANCED_SORTING_COLUMN, 'value', 'name', 'advancedSortingColumnIndex', 'tileIndex')

  const CHANGE_COLUMN_IN_TABLE = 'CHANGE_COLUMN_IN_TABLE_CUSTOM_INSIGHT'
  const changeColumnInTable = ActionService.makeActionCreator(CHANGE_COLUMN_IN_TABLE, 'value', 'name', 'columnIndex', 'tileIndex')

  const CHANGE_ROW_CONFIG_IN_TABLE = 'CHANGE_ROW_CONFIG_IN_TABLE_CUSTOM_INSIGHT'
  const changeRowConfigInTable = ActionService.makeActionCreator(CHANGE_ROW_CONFIG_IN_TABLE, 'value', 'name', 'rowConfigIndex', 'tileIndex')

  const REMOVE_COLUMN = 'REMOVE_COLUMN_CUSTOM_INSIGHT'
  const removeColumn = ActionService.makeActionCreator(REMOVE_COLUMN, 'columnIndex', 'tileIndex')

  const ADD_CONTEXT_MENU_ITEM = 'ADD_CONTEXT_MENU_ITEM_TABLE_CUSTOM_INSIGHT'
  const addContextMenuItem = ActionService.makeActionCreator(ADD_CONTEXT_MENU_ITEM, 'index', 'value', 'menuOptionId')
  
  const REMOVE_CONTEXT_MENU_ITEM = 'REMOVE_CONTEXT_MENU_ITEM_TABLE_CUSTOM_INSIGHT'
  const removeContextMenuItem = ActionService.makeActionCreator(REMOVE_CONTEXT_MENU_ITEM, 'contextMenuIndex', 'tileIndex')

  const CHANGE_CONTEXT_MENU_ITEM = 'CHANGE_CONTEXT_MENU_ITEM_TABLE_CUSTOM_INSIGHT'
  const changeContextMenuItem = ActionService.makeActionCreator(CHANGE_CONTEXT_MENU_ITEM, 'value', 'name', 'contextMenuIndex', 'tileIndex')

  const ADD_CURVE = 'ADD_CURVE_TABLE_CUSTOM_INSIGHT'
  const addCurve = ActionService.makeActionCreator(ADD_CURVE, 'tileIndex', 'value')

  const COPY_CURVE = 'COPY_CURVE_TABLE_CUSTOM_INSIGHT'
  const copyCurve = ActionService.makeActionCreator(COPY_CURVE, 'copyIndex', 'tileIndex')

  const REMOVE_CURVE = 'REMOVE_CURVE_TABLE_CUSTOM_INSIGHT'
  const removeCurve = ActionService.makeActionCreator(REMOVE_CURVE, 'curveIndex', 'tileIndex')

  const ON_CHANGE_CURVE = 'ON_CHANGE_CURVE_TABLE_CUSTOM_INSIGHT'
  const onChangeCurve = ActionService.makeActionCreator(ON_CHANGE_CURVE, 'value', 'name', 'curveIndex', 'tileIndex')

  const ON_REORDER_CURVE = 'ON_REORDER_CURVE_TABLE_CUSTOM_INSIGHT'
  const onReorderCurve = ActionService.makeActionCreator(ON_REORDER_CURVE, 'from', 'to', 'tileIndex')

  const CONDITION_COLUMN_IDS = {
    COLUMNS_MATCHING_REGEX: "COLUMNS_MATCHING_REGEX",
    COLUMN_WITH_INDEX: "COLUMN_WITH_INDEX",
    SPECIFIC_CELL: "SPECIFIC_CELL"
  }

  const CONDITION_ROW_IDS = {
    FIRST: "FIRST",
    LAST: "LAST",
    ALL: "ALL",
    ROW_WITH_INDEX: "ROW_WITH_INDEX",
    SPECIFIC_CELL: "SPECIFIC_CELL"
  }

  const CONDITIONAL_FORMATTING_TYPES = {
    CORRECTION_DOT: "CORRECTION_DOT"
  }

  const CONDITION = {
    GREATER_THAN: ">",
    GREATER_THAN_OR_EQUAL: ">=",
    LESS_THAN: "<",
    LESS_THAN_OR_EQUAL: "<=",
    IS_EQUAL: "==",
    IS_NOT_EQUAL: "!=",
    IS_BETWEEN: "><",
    IS_NOT_BETWEEN: "<>",
    IS_ONE_OF: "!includes",
    IS_NOT_ONE_OF: "includes",
    MATCH_REGEXP: "regex",
    FOR_EVERY_DIFFERENT: "FOR_EVERY_DIFFERENT",
    IS_GREATER_BY_PREVIOUS_CELL_BY: "IS_GREATER_BY_PREVIOUS_CELL_BY",
    IS_GREATER_OR_EQUAL_THAN_PREVIOUS_CELL_BY: "IS_GREATER_OR_EQUAL_THAN_PREVIOUS_CELL_BY",
    IS_EQUAL_TO_PREVIOUS_CELL: "IS_EQUAL_TO_PREVIOUS_CELL",
    IS_NOT_EQUAL_TO_PREVIOUS_CELL: "IS_NOT_EQUAL_TO_PREVIOUS_CELL",
    IS_LESSER_THAN_PREVIOUS_CELL_BY: "IS_LESSER_THAN_PREVIOUS_CELL_BY",
    IS_LESSER_OR_EQUAL_THAN_PREVIOUS_CELL_BY: "IS_LESSER_OR_EQUAL_THAN_PREVIOUS_CELL_BY",
    IS_DIFFERENCE_BETWEEN_CELLS_BETWEEN: "IS_DIFFERENCE_BETWEEN_CELLS_BETWEEN"
  }

  const CONDITIONS = [{
    label: "Greater than",
    value: CONDITION.GREATER_THAN
  }, {
    label: "Greater than or equal to",
    value: CONDITION.GREATER_THAN_OR_EQUAL,
  }, {
    label: "Less than",
    value: CONDITION.LESS_THAN
  }, {
    label: "Less than or equal to",
    value: CONDITION.LESS_THAN_OR_EQUAL
  }, {
    label: "Is equal to",
    value: CONDITION.IS_EQUAL
  }, {
    label: "Is not equal to",
    value: CONDITION.IS_NOT_EQUAL
  }, {
    label: "Is between",
    value: CONDITION.IS_BETWEEN
  }, {
    label: "Is not between",
    value: CONDITION.IS_NOT_BETWEEN
  }, {
    label: "Is one of",
    value: CONDITION.IS_ONE_OF
  }, {
    label: "Is not one of",
    value: CONDITION.IS_NOT_ONE_OF
  }, {
    label: "Match RegExp",
    value: CONDITION.MATCH_REGEXP
  }]

  const CONDITION_PREVIOUS_COLUMNS_ONLY = [
    {
      label: "Compare cells: If greater than",
      value: CONDITION.IS_GREATER_BY_PREVIOUS_CELL_BY
    },
    {
      label: "Compare cells: If greater or equal to",
      value: CONDITION.IS_GREATER_OR_EQUAL_THAN_PREVIOUS_CELL_BY
    },
    {
      label: "Compare cells: If equal to",
      value: CONDITION.IS_EQUAL_TO_PREVIOUS_CELL
    },
    {
      label: "Compare cells: If not equal to",
      value: CONDITION.IS_NOT_EQUAL_TO_PREVIOUS_CELL
    },
    {
      label: "Compare cells: Less than",
      value: CONDITION.IS_LESSER_THAN_PREVIOUS_CELL_BY
    },
    {
      label: "Compare cells: Less or equal to",
      value: CONDITION.IS_LESSER_OR_EQUAL_THAN_PREVIOUS_CELL_BY
    },
    {
      label: "Compare cells: Difference between (range)",
      value: CONDITION.IS_DIFFERENCE_BETWEEN_CELLS_BETWEEN
    }
  ]

  const CONDITION_COLUMNS_ONLY = [
    {
      label: "For every different value",
      value: CONDITION.FOR_EVERY_DIFFERENT
    },
    ...CONDITION_PREVIOUS_COLUMNS_ONLY
  ]

  const TABLE_DYNAMIC_CONST_COLUMNS = {
    TRANSACTION_DATE: "Transaction date"
  }

  const TABLE_DYNAMIC_TYPE = {
    GET_TS_DATA: "GET_TS_DATA",
    FORMULA: "FORMULA"
  }

  const TABLE_DYNAMIC_TYPES = [{
    label: "Get TimeSeries data",
    value: TABLE_DYNAMIC_TYPE.GET_TS_DATA,
    tooltipPosition: "left"
  }, {
    label: "Formula",
    value: TABLE_DYNAMIC_TYPE.FORMULA,
    tooltipPosition: "left"
  }]

  const TABLE_ROW_SHORTCUT = {
    ADD_ROW: undefined,
    DUPLICATE_ROW: "duplicateRow"
  }

  const TABLE_ROW_SHORTCUTS = [{
    label: "Add row",
    value: TABLE_ROW_SHORTCUT.ADD_ROW,
  }, {
    label: "Duplicate row",
    value: TABLE_ROW_SHORTCUT.DUPLICATE_ROW
  }]

  const TEXT_STYLES = [{
    label: "Bold",
    value: "bold"
  }, {
    label: "Standard",
    value: "normal"
  }, {
    label: "Light",
    value: "lighter"
  }]

  const VALIDATION_VALUE_TYPES = {
    DATE: {
      value: "DATE",
      label: "Date"
    },
    NUMBER: {
      value: "NUMBER",
      label: "Number"
    },
    SYMBOL: {
      value: "SYMBOL",
      label: "Symbol"
    }
  }

  const DOWNLOAD_TABLE_AS_HTML = "DOWNLOAD_TABLE_AS_HTML"

  const GET_EMPTY_ADVANCED_SORTING_COLUMN = () => ({
    columnName: undefined,
    id: CommonService.generateUID(),
    sortOrder: undefined
  })

  const EMPTY_CUSTOM_CONTEXT_MENU_ITEM = ({
    type: undefined
  })

  const SORT_ORDER = {
    ASCENDING: "Ascending",
    DESCENDING: "Descending"
  }

  const prepareOverwrittenSymbols = ({ inputParamConfig, values, row, fieldToMerge }) => {
    const symbols = {}
    inputParamConfig[fieldToMerge]?.forEach(({ symbolKey, label = symbolKey }) => {
      const columnIndex = values.findIndex(v => v.column.columnName === label || (v.column.columnName === "FuturesRoot(MD-S)" && label === "Root"))
      if(columnIndex > -1) {
        symbols[symbolKey] = row.values[columnIndex]?.rawValue
      } else {
        symbols[symbolKey] = inputParamConfig.symbols?.[symbolKey] || inputParamConfig.metadatas?.[symbolKey]
      }
    })
    return symbols;
  }

  const prepareOverwrittenFileColumns = ({ inputParamConfig, values, row }) => {
    const fileColumns = {}
    inputParamConfig.fileColumns?.forEach(({ column, label = column, ...props }) => {
      const columnIndex = values.findIndex(v => v.column.columnName === label)
      if(columnIndex > -1) {
        fileColumns[column] = {
          ...props,
          value: row.values[columnIndex]?.rawValue,
        }
      } else {
        fileColumns[column] = {
          ...props
        }
      }
    })
    return fileColumns;
  }

  const goToDetails = ({ values, config, row, ...rest }) => dispatch => {
    const { tileIds, scrollOnPreview, scrollOnPreviewTileId } = config || {}
    tileIds?.forEach(tileId => {
      // we have to read here config with user input to attach it to dispatch for user selection
      const inputParamConfig = dispatch(inputParamsCustomInsightActions.getInputParamsConfigWithUserInput({ sourceInputParamsId: tileId }))
      let inputParamsOverwritting;
      if(inputParamConfig.basicInputParamsType === inputParamsCustomInsightActions.BASIC_INPUT_PARAM_TYPES.TS.value) {
        const symbols = prepareOverwrittenSymbols({ inputParamConfig, values, row, fieldToMerge: 'keys' })
        dispatch(inputParamsCustomInsightActions.onChangeInputParamsUserSelection(symbols, "symbols", tileId))
        inputParamsOverwritting = { from: undefined, to: undefined, symbols }
      } else if(inputParamConfig.basicInputParamsType === inputParamsCustomInsightActions.BASIC_INPUT_PARAM_TYPES.CURVE.value) {
        const symbols = prepareOverwrittenSymbols({ inputParamConfig, values, row, fieldToMerge: 'curveKeys' })
        dispatch(inputParamsCustomInsightActions.onChangeInputParamsUserSelection(symbols, "symbols", tileId))
        inputParamsOverwritting = { symbols }
      } else {
        const fileColumns = prepareOverwrittenFileColumns({ inputParamConfig, values, row })
        dispatch(inputParamsCustomInsightActions.onChangeInputParamsUserSelection(fileColumns, "fileColumns", tileId))
        inputParamsOverwritting = { fileColumns }
      }
      // we execute the input params with overwritten values
      dispatch(inputParamsCustomInsightActions.executeSingleInputParam({ overwrittenInputParameters: inputParamsOverwritting, inputParamId: tileId, withMessage: true, ...rest }))
      dispatch(inputParamsCustomInsightActions.executeSyncInputParams({ overwrittenInputParameters: inputParamsOverwritting, inputParamId: tileId, ...rest }))
    })

    if(scrollOnPreview) {
      document.getElementById(scrollOnPreviewTileId)?.scrollIntoView?.({ behavior: 'smooth' })
    }
  }

  const onFileParseError = ({ error, onError, onHandleRequest }) => dispatch => {
    onError ? onError() : dispatch(globalActions.getMessageStore()).error("CSV file can not be parsed.")
    console.error(error)
    onHandleRequest({ isResponse: true })
    return Promise.resolve()
  }

  const onFileComplete = ({ additionalColumns = [], shouldNormalizeAdditionalColumns = false, result, onError, onHandleRequest, onComplete }) => dispatch => {
    const newResult = result?.data || []
    if(newResult[newResult?.length - 1]?.length !== newResult[0]?.length) {
      newResult.pop()
    }
    if(result?.errors.length !== 0) {
      if(result?.data?.length === 0){
        dispatch(globalActions.getMessageStore()).error("No data has been received.")
      }
      return dispatch(onFileParseError({ error: result?.errors, onError, onHandleRequest }))
    } else {
      if(JSON.stringify(result?.meta?.fields || []) === JSON.stringify(["status", "message"]) && newResult.length === 1) {
        if(newResult?.[0]?.status === "400") {
          onError?.()
          onHandleRequest({ isResponse: true })
        } else {
          dispatch(globalActions.getMessageStore()).error(newResult?.[0]?.message)
          onError?.() // false
          onHandleRequest({ isResponse: true })
        }
      } else {
        const normalizedResult = getNormalizedTableColumnsAndData({
          additionalColumns,
          shouldNormalizeAdditionalColumns,
          columns: result?.meta?.fields || [],
          data: newResult
        })

        onComplete(normalizedResult)
        onHandleRequest({ isResponse: true })
      }
    }
  }

  const getBody = ({ columns, corrections = DataStorageEnums.CORRECTION.FALSE, csvFormat = DataStorageEnums.DATA_FORMAT.NCSV, csvHeaders, dataRange, decimalPrecision, filters, from, groupName, includeFileId = false, includeUser = false, lastType, lastValue, symbols, metadatas, specificDate, timezone, to, dateFormat, withMetadata = false, patternExactMatch = false, requestedMetadataFields, symbolValuesExactMatch = true, metaDataExactMatch = true, useSavedByWhenIncludingUser = false, sources = [undefined] }) => {
    let builder = new GetDataBody.Builder()
    if(
        (
          !symbols || 
          Object.values(symbols).every(v => v === undefined || (Array.isArray(v) && v.every(v => v === undefined)))
        ) &&
        (
          !metadatas || 
          Object.values(metadatas).every(v => v === undefined || (Array.isArray(v) && v.every(v => v === undefined)))
        )
      ) 
        {
          return builder.build().serialize()
        }

    if((to || from) && dataRange === DataStorageEnums.DATA_RANGE.BETWEEN) {
      builder = builder
        .withRange(DataStorageEnums.DATA_RANGE.BETWEEN)
        .withStartDate(from ? dayjs.utc(from +  "T00:00:00.000").format(TimeService.ISO_DATE_TIME_FORMAT_BACKEND_WITH_SECONDS_STYLE): undefined)
        .withEndDate(to ? dayjs.utc(to +  "T23:59:59.999").format(TimeService.ISO_DATE_TIME_FORMAT_BACKEND_WITH_SECONDS_STYLE) : undefined)
    } else if(dataRange === basicCustomInsightConsts.CUSTOM_DATE_RANGES.SPECIFIC_DATE.value) {
      const specificDateFrom = specificDate ? dayjs.utc(specificDate + "T00:00:00.000").format(TimeService.ISO_DATE_TIME_FORMAT_BACKEND_WITH_SECONDS_STYLE) : undefined,
            specificDateTo = specificDate ? dayjs.utc(specificDate + "T23:59:59.999").format(TimeService.ISO_DATE_TIME_FORMAT_BACKEND_WITH_SECONDS_STYLE) : undefined
      builder = builder
              .withStartDate(specificDateFrom === "undefined" || specificDateFrom === "Invalid Date" ? undefined : specificDateFrom)
              .withEndDate(specificDateTo === "undefined" || specificDateTo === "Invalid Date" ? undefined : specificDateTo)
              .withRange(DataStorageEnums.DATA_RANGE.BETWEEN)
    } else {
      builder = builder
        // .withRange(DataStorageEnums.DATA_RANGE.ALL) not working due to bug in stream
        .withRange(DataStorageEnums.DATA_RANGE.LAST)
        .withLastType(lastType === DataStorageEnums.DATA_RANGE.LAST ? DataStorageEnums.LAST_TYPE.VALUE : lastType) // fallback for wrongly saved insights
        .withLastTypeAmount(dataRange === DataStorageEnums.DATA_RANGE.LAST ? lastValue : 100000)
        
    }
    const allKeysCombinations = basicCustomInsightActions.generateKeysCombinations({ symbols, metadatas })
    // sources (input params with All providers): every key is asked on each environment of the group (/ts/stream/envs)
    allKeysCombinations?.forEach(({ symbols, metadatas }) => sources.forEach(source => {
      const key = new Key.Builder()
        .withColumns(columns?.indexOf("*") > -1 ? undefined : columns)
        .withSymbols(symbols)
        .withMetadatas(metadatas)
        .withGroupName(groupName)
        .withPattern(true)
        .withPatternExactMatch(patternExactMatch)
        .withMetadataExactMatch(metaDataExactMatch)
        .withSymbolValuesExactMatch(symbolValuesExactMatch)
        .withSource(source)
        builder = builder.withKey(key.build().serialize())
    }))

    const body = builder
      .withMetadata(withMetadata)
      .withDateFormat(dateFormat)
      .withTimeZone(timezone)
      .withFormatType(csvFormat)
      .withCorrections(corrections)
      .withIncludeFileId(includeFileId)
      .withIncludeUser(includeUser)
      .withRequestedMetadataFields(requestedMetadataFields)
      .withUseSavedByWhenIncludingUser(useSavedByWhenIncludingUser)
      .withCsvHeaders(csvFormat === DataStorageEnums.DATA_FORMAT.CSV && csvHeaders ? csvHeaders.filter(c => c).map(c => ({ name: c.value, type: c.type })) : undefined)
      .withDecimalPrecision(decimalPrecision === "" ? undefined : decimalPrecision)
      .withFilters(filters)
      .build()
      .serialize()
    return body
  }

  const getSourceTileData = ({ inputParams, onComplete, onError, onHandleRequest, provider, useEnvs = false, sources }) => dispatch => {
    const body = getBody({ ...inputParams, sources })
    if(body.keys?.length < 1 && !body.groupName) {
      return;
    }
    const shouldNormalizeAdditionalColumns = !!(inputParams.withColumnSelector || (inputParams.isFormulaSource && (inputParams.columns?.length > 1 || inputParams.columns?.includes(ALL_COLUMNS_VALUE))))
    return dispatch(getTileData({
      additionalColumns: inputParams.columns,
      shouldNormalizeAdditionalColumns,
      body,
      onComplete,
      onError,
      onHandleRequest,
      provider,
      useEnvs
    }))
  }

  const getCorrectionsTileBody = inputParams =>
    getBody({
      ...inputParams,
      corrections: properties.warehouse_only === "true" || properties.warehouse_hybrid === "true" ? DataStorageEnums.CORRECTION.TRUE : DataStorageEnums.CORRECTION.HISTORY,
      csvFormat: DataStorageEnums.DATA_FORMAT.JSON,
      includeFileId: true,
      includeUser: true,
      requestedMetadataFields: DataLakeReadableConsts.METADATA_FIELDS_TYPES.map(({ value }) => value),
      useSavedByWhenIncludingUser: true
    })

  const getTileData = ({ additionalColumns = [], shouldNormalizeAdditionalColumns = false, body, onComplete, onError, onHandleRequest, provider, useEnvs = false }) => dispatch => {
    onHandleRequest()
    const bodyLoc = {
        ...body,
        source: body.source || dispatch(getApiConfig()).withWareHouseService() === "ON" ? "WarehouseService" : null,
      }
    const apiBuilder = new Query.Builder(dispatch(getApiConfig()))
      .post(bodyLoc)
      .withFunctionName(useEnvs ? "tsStreamEnvs" : "tsStream")
      .withQueryParameter("size", -1)
      .withQueryParameter("order", CommonEnums.SORT_ORDER.DESCENDING)
      .withQueryParameter("omitNulls", false)
      .withQueryParameter("absoluteSize", basicCustomInsightConsts.ABSOLUTE_SIZE)
      .withHeader('Content-Type', 'application/json')
      .withHeader('Accept', '*/*')
      .withHeader('Expect', 'text/csv')
      .withHeader("Target", provider, true)
      .withProxy(dispatch(basicCustomInsightActions.getProxy()))
      .withFetching(false)
      .build()

    const { url, fetchObj } = apiBuilder.getCallProps()

    return Papa.parse(url, {
      download: true,
      downloadRequestHeaders: fetchObj.headers,
      downloadRequestBody: fetchObj.body,
      complete: result => result && dispatch(onFileComplete({ additionalColumns, shouldNormalizeAdditionalColumns, result, onError, onHandleRequest, onComplete })),
      error: error => dispatch(onFileParseError({ error, onError, onHandleRequest })),
      skipEmptyLines: true,
      header: true,
      worker: true,
      preview: basicCustomInsightConsts.ABSOLUTE_SIZE
    })
  }

  // Promise form of getTileData for callers outside an insight, e.g. the Datalake Review output preview.
  // Passing the selected columns renames duplicated symbol headers to `Symbol::Column`, as a tile with a column selector does.
  const fetchTileData = ({ body, provider, additionalColumns = [] }) => dispatch => new Promise((resolve, reject) => {
    dispatch(getTileData({
      additionalColumns,
      shouldNormalizeAdditionalColumns: additionalColumns.length > 0,
      body,
      onComplete: resolve,
      onError: () => reject(new Error(TILE_DATA_ERROR_MESSAGE)),
      onHandleRequest: () => {},
      provider
    }))
  })

  const addTopBorderToRow = (bgColor, defaultStyle, itemIndex, index) => {
    if (bgColor === "light-dark(#ffffff, #1f1f1f)" && Object.values(defaultStyle)[itemIndex - 1]?.bgColor && index === 0 ) return "1px solid light-dark(#e6e6e6, #494b4b)" 
  }

  const onTileOverwriteConfigChange = ({ outputTile, type, value }) => (dispatch, getState) => {
    const currentTileOverwrite = getState().insightState.customState.tileOverwrite

    dispatch(basicCustomInsightActions.onChange(ReduxService.updateObject(currentTileOverwrite, {
      [outputTile]: ReduxService.updateObject(currentTileOverwrite?.[outputTile], { 
        // setting file details to find it on data lake + clearing the previous file id
        // insight tile should resolve new id after finding this file
        currFileId: undefined,
        source: {
          type,
          value
        }
      })
    }), "tileOverwrite"))
  }

  const addFormulaColumn = ({ columnIds, columnsConfig, hasFormulaColumn, tileId }) => dispatch => {
    const newColumnId = getNewColumnName({ columnIds })

    if(!hasFormulaColumn) {
      const newFormulaColumn = {
        columnId: newColumnId,
        isCreatedWithFormulaCreator: true,
        columnType: basicCustomInsightConsts.COLUMN_TYPES.DYNAMIC,
        asyncCallType: TABLE_DYNAMIC_TYPE.FORMULA,
        columnAsyncFormula: ""
      }

      dispatch(basicCustomInsightActions.onChangeTileOverwriteItem(columnsConfig.add(newFormulaColumn), "columns", tileId))
      dispatch(basicCustomInsightActions.onChangeTileOverwriteItem(false, "isFormulaSaved", tileId))
      dispatch(basicCustomInsightActions.onChange(newColumnId, 'activeFormulaColumnId'))
    } else {
      dispatch(basicCustomInsightActions.onChange(undefined, 'activeFormulaColumnId'))
    }

    dispatch(basicCustomInsightActions.onChange(true, 'activeFormulaWithOptionalSave'))
    dispatch(basicCustomInsightActions.onChange(tileId, 'activeFormulaTileId'))
  }

  const clearFormulaColumn = ({ tileId }) => dispatch => {
    dispatch(basicCustomInsightActions.onChange(undefined, 'activeFormulaTileId'))
    dispatch(basicCustomInsightActions.onChange(undefined, 'activeFormulaColumnId'))
    dispatch(basicCustomInsightActions.onChangeTileOverwriteItem(undefined, "formulaPanel", tileId))
    dispatch(basicCustomInsightActions.onChangeTileOverwriteItem(false, "isFormulaSaved", tileId))
    dispatch(basicCustomInsightActions.onChangeTileOverwriteItem([], "columns", tileId))
  }
  
  const getNewColumnName = ({ columnIds, currentColumnId, preferredName = NEW_FORMULA_COLUMN_NAME }) => {
    let newName = preferredName || NEW_FORMULA_COLUMN_NAME
    while((columnIds || []).filter(columnId => columnId !== currentColumnId).includes(newName)) {
      newName = `${newName}(1)`
    }
    return newName
  }
  
  const MATCH_FILE_NAME_OPTION = {
    COLUMN_HEADER_VALUE: {
      label: "Column header value",
      value: "columnHeaderValue"
    },
    CELL_VALUE: {
      label: "Cell value",
      value: "CELL_VALUE"
    }
  }

  return {
    ADD_COLUMN,
    addColumn,
    CHANGE_COLUMN_IN_TABLE,
    changeColumnInTable,
    CHANGE_ROW_CONFIG_IN_TABLE,
    changeRowConfigInTable,
    REMOVE_COLUMN,
    removeColumn,
    ADD_CONDITIONAL_FORMATTING,
    addConditionalFormatting,
    REMOVE_CONDITIONAL_FORMATTING,
    removeConditionalFormatting,
    CHANGE_CONDITIONAL_FORMATTING,
    ADD_ADVANCED_SORTING_COLUMN,
    addAdvancedSortingColumn,
    REMOVE_ADVANCED_SORTING_COLUMN,
    removeAdvancedSortingColumn,
    CHANGE_ADVANCED_SORTING_COLUMN,
    changeAdvancedSortingColumn,
    changeConditionalFormatting,
    CONDITION_ROW_IDS,
    CONDITION_COLUMN_IDS,
    CONDITIONAL_FORMATTING_TYPES,
    CONDITION,
    CONDITIONS,
    CONDITION_COLUMNS_ONLY,
    TEXT_STYLES,
    goToDetails,
    getSourceTileData,
    getCorrectionsTileBody,
    onFileComplete,
    onFileParseError,
    DOWNLOAD_TABLE_AS_HTML,
    TABLE_DYNAMIC_TYPES,
    TABLE_DYNAMIC_TYPE,
    TABLE_ROW_SHORTCUT,
    TABLE_ROW_SHORTCUTS,
    TABLE_DYNAMIC_CONST_COLUMNS,
    GET_EMPTY_ADVANCED_SORTING_COLUMN,
    SORT_ORDER,
    getTileData,
    fetchTileData,
    addTopBorderToRow,
    EMPTY_CUSTOM_CONTEXT_MENU_ITEM,
    addContextMenuItem,
    removeContextMenuItem,
    changeContextMenuItem,
    ADD_CONTEXT_MENU_ITEM,
    CHANGE_CONTEXT_MENU_ITEM,
    REMOVE_CONTEXT_MENU_ITEM,
    VALIDATION_VALUE_TYPES,
    onTileOverwriteConfigChange,
    MATCH_FILE_NAME_OPTION,
    CONDITION_PREVIOUS_COLUMNS_ONLY,
    COPY_CONDITIONAL_FORMATTING,
    copyConditionalFormatting,
    addCurve,
    ADD_CURVE,
    copyCurve,
    COPY_CURVE,
    removeCurve,
    REMOVE_CURVE,
    onChangeCurve,
    ON_CHANGE_CURVE,
    onReorderCurve,
    ON_REORDER_CURVE,
    addFormulaColumn,
    clearFormulaColumn,
    getNewColumnName,
    getBody
  }
})()
